import { Button, FormInstance } from "antd"
import { FC, SetStateAction } from "react"
import { useStore } from "stores/utils/use-store"
import { SchedulingImage } from "./SchedulingImage"
import { SchedulingTimeline } from "./SchedulingTimeline"
import moment from "moment"
import { ContestConfig, ContestConfigLiveData, ContestConfigSchedulePageData } from "domains/managingJson/store/types"
import { FormElement } from "components"
import { resolvePeriodLabel } from "./resolvePeriodLabel"

export const SchedulingTab: FC<{
  form: FormInstance<any>
  constestLive: ContestConfigLiveData[]
  setContestLive: React.Dispatch<SetStateAction<ContestConfigLiveData[]>>
  notStarted: ContestConfigSchedulePageData
  setNotStarted: React.Dispatch<SetStateAction<ContestConfigSchedulePageData>>
  finished: ContestConfigSchedulePageData & {
    CTAtext: string;
  }
  setFinished: React.Dispatch<SetStateAction<ContestConfigSchedulePageData & {
    CTAtext: string;
}>>
}> = ({ form, constestLive, setContestLive, notStarted, setNotStarted, finished, setFinished }) => {

  const { dataStore: { managingJsonStore: { selectedElement } } } = useStore()
  const data = selectedElement.data as ContestConfig

  const deleteWeek = (index: number) => {
    const arr = constestLive.filter((_, i) => i !== index)
    setContestLive(arr)

    if (arr.length === index && arr.length > 0) {
      data.endDate = arr[index - 1].endDate
    }

    if (index === 0 && arr.length > 0) {
      data.startDate = arr[0].startDate
    }

    for (let i = index; i < arr.length; i++) {
      form.setFieldValue(`periodName${i + 1}`, arr[i].periodName ?? `Period ${i + 1}`)
      form.setFieldValue(`weekTitle${i + 1}`, arr[i].title)
      form.setFieldValue(`weekText${i + 1}`, arr[i].text)
    }
  }

  const addWeek = () => {
    const newPeriodStartDate = constestLive.length > 0
      ? moment.utc(constestLive[constestLive.length - 1].endDate).add(1, "s").toDate()
      : data.startDate ?? new Date()

    const arr = [...constestLive, {
      periodName: `Period ${constestLive.length + 1}`,
      title: "",
      text: "",
      startDate: newPeriodStartDate,
      endDate: newPeriodStartDate,
      image: "",
    }]
    setContestLive(arr)
  }

  return (
    <div style={{ background: "#F0F2F5", margin: "-16px", padding: "24px 48px" }}>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Schedule Overview (updated after save)</div>
        <SchedulingTimeline weeks={constestLive} />
      </div>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Main page</div>
        <div style={{ width: "30%", marginRight: "16px" }}>
          Game producer&apos;s disclaimer
          <FormElement
            type="input"
            label=""
            name="gameProducerDisclaimer"
            initialValue={data.gameProducerDisclaimer}
          />
        </div>
      </div>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Not Started</div>
        <SchedulingImage
          step={notStarted as any}
          name="Contest Not Started Schedule"
          setter={setNotStarted}
        />
      </div>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px", display: "flex" }}>
            Contest is Live
          <Button style={{ marginLeft: "auto" }} type="primary" onClick={addWeek}>Add period</Button>
        </div>
        <div style={{ display: "flex", marginBottom: "24px", flexWrap: "wrap" }}>
          {constestLive.map((step, index) => (
            <SchedulingImage
              key={index}
              step={step as any}
              index={index}
              name={resolvePeriodLabel(step.periodName, index)}
              deleteFunc={() => {
                deleteWeek(index)
              }}
              weeks={constestLive}
              setContestLive={setContestLive}
            />
          ))}
        </div>
      </div>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Finished</div>
        <SchedulingImage
          step={finished}
          name="Contest Finished Schedule"
          finish
          setter={setFinished as any}
        />
      </div>
    </div>
  )

}
